function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TurksAndCaicosIslandsFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_1199",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_1199)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_1199",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_1199)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.785 10.5245C15.785 10.5245 16.4496 19.473 19.4465 19.473C22.4434 19.473 23.1805 10.5245 23.1805 10.5245H15.785Z",
        fill: "#FECA00",
        stroke: "#F7FCFF",
        strokeWidth: "0.25"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.4334 10.9664L19.5432 10.8424L20.0636 11.174C20.139 11.0568 20.2733 11.0023 20.4612 11.0113L20.2714 10.7222L20.426 10.6398L20.7863 11.0736C20.7981 11.0772 20.8099 11.0809 20.8219 11.0848L20.7306 10.5211L20.9117 10.5L21.0301 11.2304C21.033 11.2303 21.0358 11.2302 21.0387 11.2302C21.0897 11.2302 21.1471 11.2548 21.2062 11.2939L21.3348 10.5L21.5159 10.5211L21.4246 11.0848C21.4366 11.0809 21.4485 11.0772 21.4602 11.0736L21.8205 10.6398L21.9752 10.7222L21.7853 11.0113C21.9733 11.0023 22.1075 11.0568 22.1829 11.174L22.7033 10.8424L22.8131 10.9664L22.2421 11.3301C22.2499 11.3713 22.2539 11.4163 22.2539 11.4653V11.5497L23.0419 11.377L23.1001 11.5235L22.2539 11.8234V11.9257L23.0561 11.8608L23.0803 12.0143L22.2539 12.1346V12.3114L23.0823 12.4483L23.0489 12.6007L22.2539 12.4819V14.2055H22.132V12.4637L21.5986 12.3839C21.5388 12.8057 21.4715 13.3366 21.4809 13.5286C21.4903 13.7183 21.6319 13.7996 21.7313 13.8566C21.8086 13.901 21.8604 13.9308 21.8045 13.9854C21.6769 14.1104 21.3578 14.2302 21.0387 14.2302C20.7195 14.2302 20.4047 14.1104 20.3365 13.9854C20.3243 13.9632 20.3259 13.965 20.3368 13.9775C20.3872 14.0352 20.6361 14.3208 20.6556 13.5286C20.6663 13.094 20.6025 12.7016 20.5292 12.4017L20.1146 12.4637V14.2055H19.9927V12.4819L19.1976 12.6007L19.1642 12.4483L19.9927 12.3114V12.1346L19.1663 12.0143L19.1904 11.8608L19.9927 11.9257V11.8234L19.1465 11.5235L19.2046 11.377L19.9927 11.5497V11.4653C19.9927 11.4163 19.9966 11.3713 20.0044 11.3301L19.4334 10.9664ZM20.4764 12.205C20.4788 12.2133 20.4813 12.2218 20.4837 12.2303L20.1146 12.2913V12.1523L20.4764 12.205ZM20.4841 11.6357C20.4785 11.6419 20.4731 11.6479 20.4678 11.6538L20.1146 11.5764V11.4653C20.1146 11.4432 20.1154 11.422 20.1171 11.402L20.4841 11.6357ZM20.7189 11.4036C20.6779 11.4389 20.6374 11.477 20.5991 11.5151L20.163 11.2373C20.2242 11.1309 20.3449 11.0922 20.5327 11.1201L20.7189 11.4036ZM21.5208 11.5957L22.0836 11.2373C22.0223 11.1309 21.9017 11.0922 21.7139 11.1201L21.4528 11.5176C21.4767 11.5439 21.4995 11.5703 21.5208 11.5957ZM21.7106 11.6687L22.1294 11.402C22.1311 11.422 22.132 11.4432 22.132 11.4653V11.5764L21.7106 11.6687ZM21.8793 11.9561L22.132 11.8665V11.9356L21.8793 11.9561ZM21.6847 12.2174L22.132 12.1523V12.2913L21.6847 12.2174ZM20.1146 11.8665V11.9356L20.3672 11.9561L20.1146 11.8665Z",
        fill: "#CF6900"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6586 14.8821C18.6586 14.8821 17.6733 16.5322 17.6733 17.5323C17.6733 17.5323 18.3447 18.0648 19.4994 18.0648C20.6542 18.0648 21.2484 17.5323 21.2484 17.5323C20.9232 16.3467 20.3699 14.8821 20.3699 14.8821H18.6586Z",
        fill: "#00A727"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.7065 14.4264C18.7065 13.9719 19.0749 13.6036 19.5293 13.6036V13.6036C19.9837 13.6036 20.3521 13.9719 20.3521 14.4264V14.9892H18.7065V14.4264Z",
        fill: "#E31D1C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.1394 12.6251C16.1394 12.6251 17.4398 12.893 17.4398 13.3155C17.4398 13.7379 17.9634 13.8902 18.0921 13.776C18.2207 13.6618 19.1269 13.5819 19.1269 13.0313C19.1269 12.4807 19.2025 12.3308 18.9824 11.9811C18.7623 11.6315 18.3033 10.4495 18.1977 10.9231C18.0921 11.3966 17.9331 11.7474 17.6394 11.4652C17.3457 11.1829 16.9685 10.5853 16.8361 10.9231C16.7037 11.2609 17.2557 11.6 16.8361 11.6C16.4165 11.6 16.7123 11.6221 16.7123 11.9081C16.7123 12.1942 16.762 12.4638 16.4507 12.4638C16.1394 12.4638 16.1394 12.6251 16.1394 12.6251Z",
        fill: "#FF927F"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_1199",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "14",
        height: "11",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "13.5",
          height: "10.5",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_1199)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.50317 12.7499L1.46754 14.0528L13.5674 4.41656L15.1344 2.48041L11.9577 2.04494L7.02241 6.19746L3.05003 8.99528L-1.50317 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.0965 13.6627L0.416945 14.4188L14.5717 2.30054H12.4467L-1.0965 13.6627Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M15.0032 12.7499L12.0325 14.0528L-0.0673752 4.41656L-1.63436 2.48041L1.54239 2.04494L6.47765 6.19746L10.45 8.99528L15.0032 12.7499Z",
          fill: "#F7FCFF"
        }), /*#__PURE__*/_jsx("path", {
          d: "M14.9019 13.405L13.3884 14.1611L7.36117 8.9726L5.57422 8.39291L-1.78515 2.48701H0.339895L7.69513 8.25273L9.64885 8.94784L14.9019 13.405Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsxs("mask", {
          id: "path-14-outside-1_621_1199",
          maskUnits: "userSpaceOnUse",
          x: "-1",
          y: "2",
          width: "16",
          height: "13",
          fill: "black",
          children: [/*#__PURE__*/_jsx("rect", {
            fill: "white",
            x: "-1",
            y: "2",
            width: "16",
            height: "13"
          }), /*#__PURE__*/_jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z"
          })]
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.48838 3H5.98838V7.5H0V9H5.98838V13.5H7.48838V9H13.5V7.5H7.48838V3Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M5.98838 3V2.25H5.23838V3H5.98838ZM7.48838 3H8.23838V2.25H7.48838V3ZM5.98838 7.5V8.25H6.73838V7.5H5.98838ZM0 7.5V6.75H-0.75V7.5H0ZM0 9H-0.75V9.75H0V9ZM5.98838 9H6.73838V8.25H5.98838V9ZM5.98838 13.5H5.23838V14.25H5.98838V13.5ZM7.48838 13.5V14.25H8.23838V13.5H7.48838ZM7.48838 9V8.25H6.73838V9H7.48838ZM13.5 9V9.75H14.25V9H13.5ZM13.5 7.5H14.25V6.75H13.5V7.5ZM7.48838 7.5H6.73838V8.25H7.48838V7.5ZM5.98838 3.75H7.48838V2.25H5.98838V3.75ZM6.73838 7.5V3H5.23838V7.5H6.73838ZM0 8.25H5.98838V6.75H0V8.25ZM0.75 9V7.5H-0.75V9H0.75ZM5.98838 8.25H0V9.75H5.98838V8.25ZM6.73838 13.5V9H5.23838V13.5H6.73838ZM7.48838 12.75H5.98838V14.25H7.48838V12.75ZM6.73838 9V13.5H8.23838V9H6.73838ZM13.5 8.25H7.48838V9.75H13.5V8.25ZM12.75 7.5V9H14.25V7.5H12.75ZM7.48838 8.25H13.5V6.75H7.48838V8.25ZM6.73838 3V7.5H8.23838V3H6.73838Z",
          fill: "#F7FCFF",
          mask: "url(#path-14-outside-1_621_1199)"
        })]
      })]
    })]
  })]
}));
//# sourceMappingURL=TurksAndCaicosIslands.js.map